var styles = {
  "Button": "Online-Store-UI-Button_ky29r",
  "iconOnly": "Online-Store-UI-Button--iconOnly_1nerb"
};

export { styles as default };
